import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import FormSelect from '../form/FormSelect';
import ShiftContainer from '../../containers/Shift';
import FormMultiSelect from '../form/FormMultiSelect';
import { withStyles } from '@material-ui/core';

import { getStyleForShiftId } from '../../libs/calendarConfig';

const styles = () => {
	return {};
};

class ShiftSelect extends PureComponent {
	componentDidMount() {
		const { shifts, searchShifts } = this.props;
		if (_.isEmpty(shifts)) {
			searchShifts();
		}
	}

	render() {
		const { shifts, selectMultiple, value } = this.props;

		if (_.isEmpty(shifts)) {
			return <div>Fetching shifts..</div>;
		}

		const options = shifts.map((shift) => {
			const { shiftId, display } = shift;

			let style = getStyleForShiftId({ shiftId, status: 'full' });
			style = _.extend(style, {
				padding: `3px 0px`,
				borderRadius: 100,
				display: 'inline-block',
				//fontSize : 13,
			});
			return {
				value: shiftId,
				display: (
					<div style={style}>
						<span style={{ padding: '4px 8px' }}>{display}</span>
					</div>
				),
				style,
			};
		});

		if (selectMultiple) {
			return (
				<FormMultiSelect
					{...this.props}
					value={_.isEmpty(options) ? [] : value}
					options={options}
				/>
			);
		} else {
			return <FormSelect {...this.props} options={options} />;
		}
	}
}

ShiftSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]),
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,
	selectMultiple: PropTypes.bool,

	classes: PropTypes.object,
	helpText: PropTypes.string,
};

ShiftSelect.defaultProps = {
	label: 'Shift',
	shifts: [],
	selectMultiple: false,
};

export default _.flow([withStyles(styles), ShiftContainer])(ShiftSelect);
